import { render, staticRenderFns } from "./GestionNoticias.vue?vue&type=template&id=73f24d49"
import script from "./GestionNoticias.vue?vue&type=script&lang=js"
export * from "./GestionNoticias.vue?vue&type=script&lang=js"
import style0 from "./GestionNoticias.vue?vue&type=style&index=0&id=73f24d49&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports